// frontend/src/askos/CurrentAffairsCard.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { askosAuthHeader } from './askosApi';
import BookmarkButton from './BookmarkButton';

const timeAgo = (iso) => {
    if (!iso) return '';
    const hours = Math.round((Date.now() - new Date(iso).getTime()) / 3600000);
    if (hours < 1) return 'just now';
    if (hours < 24) return `${hours}h ago`;
    return `${Math.round(hours / 24)}d ago`;
};

const CurrentAffairsCard = ({ slug, limit = 3 }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        api.get(`/tenant/${slug}/askos/current-affairs`, { params: { limit }, headers: askosAuthHeader() })
            .then(res => setItems(res.data || []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, [slug, limit]);

    return (
        <article className="panel">
            <div className="panel-heading">
                <h3>Current Affairs Highlights</h3>
                <a href="#" onClick={e => { e.preventDefault(); navigate('/samkalp-ias/current-affairs'); }}>View All</a>
            </div>
            {loading && <p className="empty-note">Loading…</p>}
            {!loading && items.length === 0 && <p className="empty-note">No current affairs items yet.</p>}
            {items.map(item => (
                <div key={item.id} className="news-row">
                    <a href={item.source_url} target="_blank" rel="noopener noreferrer">
                        <span>{item.source}</span>
                        <strong>{item.title}</strong>
                        <small>{timeAgo(item.published_at)}</small>
                    </a>
                    <BookmarkButton slug={slug} target={{ current_affairs_item_id: item.id }} note={item.title} />
                </div>
            ))}
            <a className="panel-link" href="#" onClick={e => { e.preventDefault(); navigate('/samkalp-ias/current-affairs'); }}>Go to Current Affairs →</a>
        </article>
    );
};

export default CurrentAffairsCard;
